import { Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React, { useState } from 'react'
import { useStrings } from '../../assets/localization/strings'
import rootStore from '../../stores/rootStore'
import { color } from '../../theme'

const PortfolioPopup = observer(() => {
  const strings = useStrings()
  const [dismissing, setDismissing] = useState(false)

  const user = rootStore.userStore.authenticatedUser
  const brand = rootStore.brandStore.selectedBrand
  const hasSeenPopup = (user as any)?.hasSeenPortfolioPopup
  const bookingFlow = (brand as any)?.bookingFlow as string | undefined

  if (!user || !brand || hasSeenPopup !== false) return null

  const isLegacy = bookingFlow === 'legacy'

  const handleDismiss = async () => {
    setDismissing(true)
    try {
      await rootStore.userStore.dismissPortfolioPopup()
    } catch (e) {
      console.error('Failed to dismiss portfolio popup:', e)
    } finally {
      setDismissing(false)
    }
  }

  const handleLearnMore = async () => {
    window.open(strings.portfolio_popup_learn_more_url, '_blank', 'noopener,noreferrer')
    await handleDismiss()
  }

  return (
    <Dialog
      open
      maxWidth='sm'
      fullWidth
      disableEscapeKeyDown
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return
      }}
      PaperProps={{
        sx: { borderRadius: '16px', p: 1 }
      }}
    >
      <DialogContent>
        {isLegacy ? (
          <Stack spacing={2}>
            <Typography variant='h2' sx={{ fontFamily: 'Bricolage Grotesque', fontWeight: 600 }}>
              {strings.portfolio_popup_legacy_title}
            </Typography>

            <Typography variant='body2' sx={{ color: color.grey2 }}>
              {strings.portfolio_popup_legacy_body}
            </Typography>

            <div>
              <Typography variant='body2' sx={{ fontWeight: 600 }}>
                {strings.portfolio_popup_legacy_good_news}
              </Typography>
              <Typography variant='body2' sx={{ color: color.grey2 }}>
                {strings.portfolio_popup_legacy_good_news_body}
              </Typography>
            </div>

            <div>
              <Typography variant='body2' sx={{ fontWeight: 600, mb: 0.5 }}>
                {strings.portfolio_popup_legacy_changes_title}
              </Typography>
              <Stack component='ul' spacing={0.5} sx={{ m: 0, pl: 2.5 }}>
                <Typography component='li' variant='body2' sx={{ color: color.grey2 }}>
                  {strings.portfolio_popup_legacy_change_1}
                </Typography>
                <Typography component='li' variant='body2' sx={{ color: color.grey2 }}>
                  {strings.portfolio_popup_legacy_change_2}
                </Typography>
                <Typography component='li' variant='body2' sx={{ color: color.grey2 }}>
                  {strings.portfolio_popup_legacy_change_3}
                </Typography>
              </Stack>
            </div>

            <div>
              <Typography variant='body2' sx={{ fontWeight: 600 }}>
                {strings.portfolio_popup_legacy_further_title}
              </Typography>
              <Typography variant='body2' sx={{ color: color.grey2 }}>
                {strings.portfolio_popup_legacy_further_body}
              </Typography>
            </div>

            <Typography variant='body2' sx={{ color: color.grey2 }}>
              {strings.portfolio_popup_legacy_further_outro}
            </Typography>
          </Stack>
        ) : (
          <Stack spacing={2}>
            <Typography variant='h2' sx={{ fontFamily: 'Bricolage Grotesque', fontWeight: 600 }}>
              {strings.portfolio_popup_other_title}
            </Typography>

            <Typography variant='body2' sx={{ color: color.grey2, whiteSpace: 'pre-line' }}>
              {strings.portfolio_popup_other_body}
            </Typography>
          </Stack>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        {isLegacy ? (
          <Button
            variant='contained'
            color='primary'
            disabled={dismissing}
            onClick={handleDismiss}
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, px: 4 }}
          >
            {strings.portfolio_popup_legacy_cta}
          </Button>
        ) : (
          <Button
            variant='contained'
            color='primary'
            disabled={dismissing}
            onClick={handleLearnMore}
            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, px: 4 }}
          >
            {strings.portfolio_popup_other_cta_learn_more}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
})

export default PortfolioPopup
